export default __webpack_public_path__ + "static/media/7.bf7b441c.jpg";